/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './item/extra-fields-list.item.component.ngfactory';
import * as i2 from '../../../../../app/shared/components/extra-fields-list/item/extra-fields-list.item.component';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/common';
import * as i5 from '../loader/loader.component.ngfactory';
import * as i6 from '../../../../../app/shared/components/loader/loader.component';
import * as i7 from '../../../../../app/shared/components/extra-fields-list/extra-fields-list.component';
import * as i8 from '../../../../../app/shared/services/http.service';
import * as i9 from '../../../../../app/shared/services/extra-field-validaton.service';
const styles_ExtraFieldsListComponent:any[] = ([] as any[]);
export const RenderType_ExtraFieldsListComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ExtraFieldsListComponent,data:{}});
function View_ExtraFieldsListComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'extra-fields-list-item',
      ([] as any[]),(null as any),[[(null as any),'extraFieldChanged']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('extraFieldChanged' === en)) {
          const pd_0:any = ((<any>_co.onExtraFieldChanged($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i1.View_ExtraFieldsListItemComponent_0,i1.RenderType_ExtraFieldsListItemComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.ExtraFieldsListItemComponent,([] as any[]),
          {extraField:[0,'extraField'],extraFieldsForm:[1,'extraFieldsForm'],validation:[2,
              'validation']},{extraFieldChanged:'extraFieldChanged'})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _v.context.$implicit;
    const currVal_1:any = _co.extraFieldsForm;
    const currVal_2:any = _co.validation;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ExtraFieldsListComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),8,'form',[['novalidate',
      '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
      (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,
      'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'submit'],[(null as any),'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,16384,(null as any),0,i3.ɵbf,([] as any[]),
      (null as any),(null as any)),i0.ɵdid(2,540672,[['f',4]],0,i3.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i0.ɵprd(2048,
      (null as any),i3.ControlContainer,(null as any),[i3.FormGroupDirective]),i0.ɵdid(4,
      16384,(null as any),0,i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),
      (null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_ExtraFieldsListComponent_2)),
      i0.ɵdid(7,802816,(null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.extraFieldsForm;
    _ck(_v,2,0,currVal_7);
    const currVal_8:any = _co.extraFields;
    _ck(_v,7,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_ExtraFieldsListComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'section',[['class',
      'extra_fields']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExtraFieldsListComponent_1)),i0.ɵdid(3,
          16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),1,'loader',([] as any[]),(null as any),
          (null as any),(null as any),i5.View_LoaderComponent_0,i5.RenderType_LoaderComponent)),
      i0.ɵdid(6,49152,(null as any),0,i6.LoaderComponent,([] as any[]),{loading:[0,
          'loading']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i7.ExtraFieldsListComponent = _v.component;
    const currVal_0:any = (_co.extraFields.length > 0);
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.loading;
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_ExtraFieldsListComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'extra-fields-list',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExtraFieldsListComponent_0,
      RenderType_ExtraFieldsListComponent)),i0.ɵdid(1,4308992,(null as any),0,i7.ExtraFieldsListComponent,
      [i8.CommonHttpService,i3.FormBuilder,i9.ExtraFieldValidatonService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ExtraFieldsListComponentNgFactory:i0.ComponentFactory<i7.ExtraFieldsListComponent> = i0.ɵccf('extra-fields-list',
    i7.ExtraFieldsListComponent,View_ExtraFieldsListComponent_Host_0,{labelKey:'labelKey',
        formSubmitted:'formSubmitted'},{valid:'valid',filled:'filled'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/app/shared/components/extra-fields-list/extra-fields-list.component.ngfactory.ts